import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Event } from "./event";
export default class MapWheelEvent extends Event {
  /**
   * @private
   */
  constructor(type, map, originalEvent) {
    super(type, {
      originalEvent
    });
    /**
     * The event type.
     */
    /**
     * The DOM event which caused the map event.
     */
    _defineProperty(this, "originalEvent", void 0);
    _defineProperty(this, "defaultPrevented", void 0);
    /**
     * The `Map` object that fired the event.
     */
    _defineProperty(this, "target", void 0);
    this.defaultPrevented = false;
  }

  /**
   * Prevents subsequent default processing of the event by the map.
   *
   * Calling this method will prevent the the behavior of {@link ScrollZoomHandler}.
   */
  preventDefault() {
    this.defaultPrevented = true;
  }
}